var _defs, _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductEarbuds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 400,
    viewBox: "0 0 640 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22c55e",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c3aed",
    stopOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 400,
    rx: 26,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 110)",
    fill: "#0b1220",
    stroke: "rgba(148,163,184,.35)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 30c0-28 22-50 50-50s50 22 50 50v72c0 22-18 40-40 40H95c-8 0-15-7-15-15V62c0-9 7-16 16-16h16V30c0-12-10-22-22-22S68 18 68 30v18c0 8-7 14-14 14H40V30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 30c0-28 22-50 50-50s50 22 50 50v72c0 22-18 40-40 40h-5c-8 0-15-7-15-15V62c0-9 7-16 16-16h16V30c0-12-10-22-22-22s-22 10-22 22v18c0 8-7 14-14 14h-14V30z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 64,
    fill: "rgba(229,231,235,.9)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto",
    fontWeight: 800,
    fontSize: 26
  }, "AirPulse Buds")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 94,
    fill: "rgba(148,163,184,.95)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto",
    fontWeight: 600,
    fontSize: 15
  }, "Punchy bass + low latency mode")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEarbuds);
export default __webpack_public_path__ + "static/media/product-earbuds.69c0cf9f5cae7c338f09a907a81d24ca.svg";
export { ForwardRef as ReactComponent };